import React from 'react';

class MediaQuery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: true
    };

    this.mediaQueryList = null;
    this.onChanged = this.onChanged.bind(this);
  }

  onChanged(event) {
    this.setState({
      matches: event.matches
    });
  }

  componentDidMount() {
    this.mediaQueryList = window.matchMedia(
      '(min-width: ' + this.props.width + 'px)'
    );
    this.setState({
      matches: this.mediaQueryList.matches
    });
    this.mediaQueryList.addListener(this.onChanged);
  }

  componentWillUnmount() {
    this.mediaQueryList.removeListener(this.onChanged);
  }

  render() {
    return this.props.children(this.state.matches);
  }
}

export default MediaQuery;
